import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-account-alerts-tab',
    templateUrl: './account-alerts-tab.component.html',
    styleUrls: ['./account-alerts-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountAlertsTabComponent {
    @Input() email = '';
    @Input() emailEnabled = false;
    @Input() smsAlertsEnabled = false;
    @Input() smsEnabled = false;
    @Input() phoneNumberDisplay = '';
    @Input() hasPhoneNumber = false;
    @Input() phoneVerified = false;
    @Output() emailToggled = new EventEmitter<void>();
    @Output() smsToggled = new EventEmitter<void>();
    @Output() manageNumber = new EventEmitter<void>();
}
